/**
 * NHL RTDB Hooks Exports
 * Centralized exports for all NHL RTDB custom hooks
 */

export { useRTDBGames } from './useRTDBGames';
export { useRTDBStandings } from './useRTDBStandings';
export { useRTDBPlayers } from './useRTDBPlayers';

// Default export - main hooks object
export default {
  useRTDBGames: require('./useRTDBGames').useRTDBGames,
  useRTDBStandings: require('./useRTDBStandings').useRTDBStandings,
  useRTDBPlayers: require('./useRTDBPlayers').useRTDBPlayers
};
